import React from 'react';

export interface ISegmentFillerProps {
  'aria-labelledby'?: string;
  fill: number;
  id?: string;
  segments: number;
}

export const SegmentFiller = ({ fill = 0, segments = 1, ...props }: ISegmentFillerProps) => {
  const segmentChunks = [];

  for (let i = 0; i < segments; i++) {
    const chunkClass = i < fill ? 'vdl-segment-filler__filled' : 'vdl-segment-filler__empty';
    segmentChunks.push(<div className={chunkClass} role="presentation"/>);
  }

  return (
    <div className="vdl-segment-filler__container" role="progressbar" aria-valuenow={fill} aria-valuemax={segments} aria-labelledby={props['aria-labelledby']}>
      {segmentChunks}
    </div>
  );
};

SegmentFiller.displayName = 'SegmentFiller';
